import {
  GeoConstants,
  HealthRecordDocumentTypeDescriptor,
  HealthRecordDocumentTypesConstants,
  PhysicianSpecialtyDescriptor,
  ProviderTitleDescriptor,
  ScpUploadWorklistConstants,
  ScpUploadWorklistStatusDescriptor,
  StateName,
  UserConstants
} from '@web/csl-lib-constants';
import { HealthRecordConstants, HealthRecordRelationshipDescriptor } from '@web/csl-lib-constants';
import { Injectable } from '@angular/core';
import { LegalGuardianConstants, LegalGuardianStatusDescriptor } from '@web/csl-lib-constants';
import { MedicalRecordReleaseConstants, MedicalRecordReleaseStatusDescriptor } from '@web/csl-lib-constants';
import { OwnerTransferConstants, OwnerTransferStatusDescriptor } from '@web/csl-lib-constants';
import { PrivilegeLevelDescriptor, ShareeRoleDescriptor, SharingConstants, SharingStatusDescriptor } from '@web/csl-lib-constants';

@Injectable({
  providedIn: 'root'
})
export class LookupsService {

  get healthRecordDocumentTypes(): HealthRecordDocumentTypeDescriptor[] {
    return HealthRecordDocumentTypesConstants.documentTypes;
  }

  get mrrStatus(): MedicalRecordReleaseStatusDescriptor[] {
    return MedicalRecordReleaseConstants.status;
  }

  get stateNames(): StateName[] {
    return GeoConstants.stateNames;
  }

  get scpUploadWorklistStatus(): ScpUploadWorklistStatusDescriptor[] {
    return ScpUploadWorklistConstants.status;
  }

  get sharingPrivilegeLevels(): PrivilegeLevelDescriptor[] {
    return SharingConstants.privilegeLevel;
  }

  get sharingStatus(): SharingStatusDescriptor[] {
    return SharingConstants.sharingState;
  }

  get shareeRoles(): ShareeRoleDescriptor[] {
    return SharingConstants.shareeRole;
  }

  get legalGuardianStatus(): LegalGuardianStatusDescriptor[] {
    return LegalGuardianConstants.status;
  }

  get ownerTransferStatus(): OwnerTransferStatusDescriptor[] {
    return OwnerTransferConstants.status;
  }

  get ownerTransferEventTypes(): OwnerTransferStatusDescriptor[] {
    return OwnerTransferConstants.eventTypes;
  }

  get ownerRelationships(): HealthRecordRelationshipDescriptor[] {
    return HealthRecordConstants.ownerRelationships;
  }

  get providerTitles(): ProviderTitleDescriptor[] {
    return UserConstants.providerTitles;
  }

  get physicianSpecialties(): PhysicianSpecialtyDescriptor[] {
    return UserConstants.physicianSpecialties;
  }

}
